<template>
	<div>
		<div class="treeMap_echarts" id="treeMap_echarts"></div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: ['echartsData'],
	data() {
		return {};
	},
	computed: {},
	watch: {},
	mounted() {
		this.getEcharts();
	},
	methods: {
		getEcharts() {
			var chartDom = document.getElementById('treeMap_echarts');
			var myChart = this.$echarts.init(chartDom);
			let option = {
				color: [
					'#afd860',
					'#7bc96f',
					'#2ca61f',
					'#43aa4e',
					'#63b265',
					'#1f9f48',
					'#08933b',
					'#307945',
				],
				grid: {},
				series: [
					{
						type: 'treemap',
						roam: false,
						nodeClick: false,
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						breadcrumb: {
							show: false,
						},
						// squareRatio:100,
						label: {
							overflow: 'break',
							fontSize: 16,
							formatter: function(params) {
								// //console.log(params)
								let bfb = (
									(params.value /
										params.treePathInfo[0].value) *
									100
								).toFixed(0);
								// return `${params.name}: ${params.value} (${bfb}%)`
								return params.name;
							},
						},
						data: [
							{
								name: '工业经济',
								value: 500,
							},
							{
								name: '环境科学与资源利用',
								value: 450,
							},
							{
								name: '企业经济',
								value: 350,
							},
							{
								name: '农业经济',
								value: 300,
							},
							{
								name: '建筑科学与工程',
								value: 250,
							},
							{
								name: '矿业工程',
								value: 200,
							},
							{
								name: '交通运输',
								value: 150,
							},
							{
								name: '更多...',
								value: 100,
							},
						],
					},
				],
			};
			let _this = this;
			myChart.setOption(option);
			myChart.on('click', function(param) {
				_this.$router.push({
					path: `/paper?id=6&name=学术论文&uid=A617&paperType=${param.data.name}`,
				});
			});
		},
	},
};
</script>
<style lang="less" scoped>
.treeMap_echarts {
	width: 401px;
	height: 263px;
}
</style>



// WEBPACK FOOTER //
// src/view/index/components/treemap/index.vue